export default __webpack_public_path__ + "static/soehne-dreiviertelfett-287de656bf8ed7b5425ca791d13dfdef.woff2";